export default {
  switch: "切換語言",
  zhCN: "簡體中文",
  zhHK: "繁體中文",
  en: "English",
};
